import { z } from 'zod';
import { RoleSchema } from './common.js';

export const LoginSchema = z.object({
  tenantSlug: z.string().min(1),
  email: z.string().email(),
  senha: z.string().min(1),
});
export type LoginDTO = z.infer<typeof LoginSchema>;

export const RefreshSchema = z.object({
  refreshToken: z.string().min(1),
});
export type RefreshDTO = z.infer<typeof RefreshSchema>;

export const AcceptInviteSchema = z.object({
  token: z.string().min(1),
  senha: z.string().min(8, 'senha deve ter ≥ 8 caracteres'),
});
export type AcceptInviteDTO = z.infer<typeof AcceptInviteSchema>;

export const TokensSchema = z.object({
  accessToken: z.string(),
  refreshToken: z.string(),
  expiresIn: z.string(),
});
export type TokensDTO = z.infer<typeof TokensSchema>;

export const PrincipalSchema = z.object({
  userId: z.string().uuid(),
  tenantId: z.string().uuid(),
  email: z.string().email(),
  nome: z.string(),
  papeis: z.array(RoleSchema),
});
export type PrincipalDTO = z.infer<typeof PrincipalSchema>;
